import { useQuery } from '@tanstack/react-query';
import type { InventoryLocation } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const inventoryLocationsQueryKey = () => ['admin', 'inventory', 'locations'] as const;

export const useInventoryLocationsQuery = () =>
  useQuery<ReadonlyArray<InventoryLocation>>({
    queryKey: inventoryLocationsQueryKey(),
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/admin/v1/inventory/locations', {});
      return (data as InventoryLocation[]) ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
